module.exports = __webpack_public_path__ + "assets/webgl/Concrete_Wall_specular.1f6e158f.jpg";